<template>
  <v-app>
    <!-- WRAPPER SAFE AREAS -->
    <div id="app-wrapper">
      <div id="app-inner">
        <v-main>
          <!-- ⏳ Loader mientras se restaura sesión -->
          <div v-if="loading" class="app-loader">
            Cargando sesión...
          </div>

          <!-- 🚀 App real -->
          <router-view v-else />
        </v-main>
      </div>
    </div>
  </v-app>
</template>

<script setup>
import { provide, watch, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { createCartStore } from "./stores/cart";
import { useUserStore } from "@/stores/userStore";
import { useTimeStore } from "./stores/timestore";

// ⏳ Loading global
const loading = ref(true);

// 🕒 Time store
const timeStore = useTimeStore();

// 🛒 Cart store
const cartStore = createCartStore();
provide("cartStore", cartStore);

// 👤 User store
const userStore = useUserStore();

onMounted(async () => {
  console.log("🚀 App.vue mounted");

  // 1️⃣ Sincronizar hora servidor
  await timeStore.syncServerTime();

  setInterval(() => timeStore.tick(), 1000);
  setInterval(() => timeStore.syncServerTime(), 5 * 60 * 1000);

  // 2️⃣ Restaurar sesión (DIDI MODE)
  if (typeof userStore.initSession === "function") {
    await userStore.initSession();
  }

  // 3️⃣ App lista
  loading.value = false;
});

// 🧭 Título dinámico
const route = useRoute();

watch(
  () => route.meta.title,
  (newTitle) => {
    document.title = newTitle || "MVExpress";
  },
  { immediate: true }
);
</script>
<style>
/* ============================= */
/*  GLOBAL SAFE AREA FIXES       */
/* ============================= */

/* 📱 App Bar (Top) - Extendemos el padding para cubrir la barra de estado con color */
.v-app-bar {
  top: 0; /* Asegura que se pegue al techo */
  /* Si env() es 0, usa 30px como respaldo */
  padding-top: env(safe-area-inset-top, 30px);
  height: calc(64px + env(safe-area-inset-top, 30px));
}

.v-toolbar__content {
  height: 64px !important; /* Mantiene el contenido centrado verticalmente */
}

/* ============================= */
/*  SAFE AREAS DEL TELÉFONO      */
/* ============================= */

/* 🔥 Ajustes globales de contenedor */
.v-application {
  padding-top: 0; /* Dejamos que el App Bar maneje el top */
  padding-bottom: env(safe-area-inset-bottom, 20px);
}

#app-wrapper {
  padding-left: env(safe-area-inset-left, 0);
  padding-right: env(safe-area-inset-right, 0);
  box-sizing: border-box;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 🔥 Forzamos que el contenido baje lo suficiente para no quedar tapado */
.v-main {
  /* 64px del header + el espacio seguro (o 30px si falla) */
  padding-top: calc(64px + env(safe-area-inset-top, 30px));
}

/* En algunos Samsung (A15) la safe-area no se reporta, así que forzamos un mínimo */
@supports (padding-bottom: env(safe-area-inset-bottom)) {
  .fixed-bottom-nav {
    padding-bottom: max(env(safe-area-inset-bottom), 25px);
  }
}

</style>
